























































import { log } from '@/log'
import { stringifyErrorForEndUser } from '@/models/payment/creditcard/repository/errors'
import { registerNewCreditcard } from '@/models/payment/creditcard/service/register-new-creditcard'
import {
  ContextToRegisterNewCreditCard,
  ReloadCreditcard,
} from '@spa/components/pages/payment/creditcard/new-creditcard/context'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import CreditcardForm from '@spa/components/organisms/payment/creditcard/CreditcardForm.vue'
import { CreditcardFormState } from '@spa/components/organisms/payment/creditcard/creditcardFormState'
import SpaCreditCardDescription from '@spa/components/organisms/payment/description/CreditCardDescription.vue'
import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'
import { User } from '@spa/store/modules/user/types'

import * as CurrentTime from '@/models/current-time/functions'
import { EventBusForThirdParty } from '@/usecases/event-bus-for-third-party/event-bus'

@Component({
  components: {
    SpaErrorDialog,
    SpaCreditCardDescription,
    CreditcardForm,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class NewCreditcard extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ required: true })
  readonly context: ContextToRegisterNewCreditCard

  @Prop({ required: true })
  readonly reloadCreditcard: ReloadCreditcard

  status: Status = Status.Pending
  showModal: boolean = false
  modalMessage: string = ''

  formState: CreditcardFormState = {
    cardNumber: '',
    cardOwner: '',
    expireMonth: '',
    expireYear: '',
    securityCode: '',
  }

  async created() {
    await this.$store.dispatch('user/get')

    EventBusForThirdParty.getInstance().publish('page-initialized', {
      url: window.location.href,
      initializedAt: CurrentTime.create().now,
      user: this.user,
    })
  }

  get cancelUrl(): string {
    return this.context.path.editPayment
  }

  get isLoading() {
    return this.status === Status.Loading
  }

  get user(): User {
    return this.$store.state.user.user
  }

  async submit() {
    try {
      const validated = await this.$validator.validateAll()

      if (!validated) {
        this.modalMessage = '入力内容が正しくありません'
        this.showModal = true

        return
      }

      this.status = Status.Loading

      await registerNewCreditcard(this.context, this.formState, this.user)

      await this.reloadCreditcard(this.$store)

      this.$router.push(this.context.path.editPayment)
    } catch (e) {
      log.error(e.message, e)

      this.modalMessage = stringifyErrorForEndUser(e)
      this.showModal = true
      this.status = Status.Failed
    }
  }
}
